exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup__block {\n  display: block;\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  z-index: 9999;\n}\n\n.popupcontainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 75%;\n  overflow: auto;\n}\n\n.popupcontainer.padding {\n  padding: 50px;\n}\n\n.popupcontainer.no-padding {\n  padding: 0px;\n}\n\n.popupcontainer p.detailtext {\n  white-space: pre-line;\n}\n\n.popupcontainer .closeicon {\n  color: #555;\n  font-size: 25px;\n  right: 15px;\n  font-weight: 400;\n  cursor: pointer;\n}\n\n.popupcontainer .productcontainer:hover {\n  color: #333;\n}\n\n.popupcontainer .payment__message {\n  margin-top: 15px;\n}\n\n.popupcontainer .closediv {\n  background-color: #EEE;\n  cursor: pointer;\n}\n\n@media (max-width: 950px) {\n  .popupcontainer {\n    margin: 0;\n    min-height: 100%;\n    max-width: 100%;\n    overflow-y: scroll;\n  }\n  .popupcontainer .closediv {\n    position: fixed;\n    z-index: 100;\n  }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/popup/popup.component.scss
// module id = ../../../../../src/app/components/popup/popup.component.scss
// module chunks = main